import createIcon from '../../createIcon';

/**
 * @component @name CurrencyYen
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuOTIgMTFIMThWMTNIMTNWMTVIMThWMTdIMTNWMjFIMTFWMTdINlYxNUgxMVYxM0g2VjExSDEwLjA4TDUgM0g3LjM3TDEyIDEwLjI5TDE2LjYzIDNIMTlMMTMuOTIgMTFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CurrencyYen = createIcon('CurrencyYen', [
  [
    'path',
    {
      d: 'M13.92 11H18V13H13V15H18V17H13V21H11V17H6V15H11V13H6V11H10.08L5 3H7.37L12 10.29L16.63 3H19L13.92 11Z',
      key: 'vz9tas',
    },
  ],
]);

export default CurrencyYen;
